import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DataService } from "../../_services/data.service";
import { GlobalDataService } from "../../_services/global-data.service";
import { MultiSelectComponent } from "../../admin/components/multi-select/multi-select.component";

@Component({
  selector: "multi-select-events",
  templateUrl: "multi-select-events.component.html",
  styleUrls: ["multi-select-events.component.scss"],
})
export class MultiSelectEventsComponent implements OnInit {
  @ViewChild("eventSelect") public nestSelect: MultiSelectComponent;
  @Input("displayType") public displayType: "legacy" | "discountScreen" =
    "legacy";
  public nestsWithCircles: any[];
  public initNestWithCircles: any[];

  constructor(
    private dataService: DataService,
    private globalDataService: GlobalDataService
  ) {}

  public ngOnInit() {
    this.loadEventData().then();
  }

  public getSelectedEvents(): any[] {
    return (this.nestSelect.submit() as any).nestForm || ([] as any[]);
  }

  private async loadEventData() {
    // this.filters = data;
    //   this.nestsWithCircles = [
    //     ...data.nestsWithCircles.circles,
    //     ...data.nestsWithCircles.counties,
    //     ...data.nestsWithCircles.nests,
    //   ];
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/multi-select-events/multi-select-events.component.ts